import React from "react";
import { Grid, FormControl, RadioGroup, Radio, Divider } from "@mui/material";
import { useDispatch } from "react-redux";
// Ensure action name matches your slice
import { setFormData } from "features/OrgAdmin/orgAdminSlice"; 
import {
  StyledFormLabel,
  StyledFormControlLabel,
} from "./AdvanceInfoStyled";

export default function FormSection({ title, name, options, value }) {
  const dispatch = useDispatch();

  const handleChange = (e) => {
    // Ham partial update bhej rahe hain
    dispatch(setFormData({ [name]: e.target.value }));
  };

  return (
    <Grid item xs={12} sm={6} md={4}>
      <FormControl component="fieldset" fullWidth>
        <StyledFormLabel component="legend">{title}:</StyledFormLabel>
        <Divider />
        <RadioGroup
          name={name}
          value={value || ""} // Parent se aayi hui prop value
          onChange={handleChange}
          sx={{ mt: 1 }}
        >
          {options.map((option) => (
            <StyledFormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  size="small"
                  sx={{
                    padding: "4px 8px",
                    "&.Mui-checked": { color: "primary.main" },
                  }}
                />
              }
              label={option.label}
              sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.7rem" } }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Grid>
  );
}